/* globals QformGroupTeams */
import 'lib/qform_group_teams'

window['qform_groups#new'] =
  window['qform_groups#edit'] = function () {
    QformGroupTeams.init()
  }
